export const GAME_BOARD_TOGGLE_RACE = "GAME_BOARD_TOGGLE_RACE";

export function gameBoardToggleRace(raceId) {
  return {
    type: GAME_BOARD_TOGGLE_RACE,
    raceId
  };
}
